export {
  baseMenuContentPropDefs as contextMenuContentPropDefs,
  baseMenuItemPropDefs as contextMenuItemPropDefs,
  baseMenuCheckboxItemPropDefs as contextMenuCheckboxItemPropDefs,
  baseMenuRadioItemPropDefs as contextMenuRadioItemPropDefs,
} from './_internal/base-menu.props.js';
